// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import type { ErrorsType } from "../../../account/types/UserFormType";
import { ErrosDisplay } from "../../../account/containers/ErrosDisplay";
import { companyDialogMessages } from "../../../account/components/companies/CompileCompanytoJson";
import { fetchCompanies } from "../../actions/billingAdminActions";
import {
  GeneralModalForm,
  LoadingProgress,
  SnackbarMessage,
  NoItem
} from "imagus-components";
import GenerateBillForm from "./GenerateBillForm";
import BillingList from "./BillingAdminList";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import BatteryCharging90Icon from "@material-ui/icons/BatteryCharging90";

type AdminFacebasesStateType = {
  errors: ErrorsType,
  messageId: number,
  modalOpen: boolean,
  snackOpen: boolean
};

class AdminBillings extends Component<*, AdminFacebasesStateType> {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      messageId: 0,
      modalOpen: false,
      snackOpen: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  componentDidMount() {
    if (!this.props.companies) {
      this.props.actions.fetchCompanies();
    }
  }

  setActionError = (errors: ErrorsType): * => {
    this.setState({
      errors: errors
    });
  };

  openSnackbar = (messageId: number): * => {
    this.setState(
      { messageId: messageId },
      this.switchModalStatus("snackOpen")(true)
    );
  };

  render(): * {
    const companies = this.props.companies && [...this.props.companies];
    let node = null;
    if (companies) {
      if (companies.length === 0) {
        node = <NoItem content="No Billing Company" />;
      } else {
        node = (
          <BillingList
            companies={companies}
            setActionError={this.setActionError}
            openSnackbar={this.openSnackbar}
          />
        );
      }
    }

    if (!node) {
      return (
        <div className="app-panel">
          <LoadingProgress />
        </div>
      );
    } else {
      return (
        <div className="app-panel">
          <div className="top-banner">
            <ErrosDisplay errors={this.state.errors} form="admin billings" />
          </div>
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus("snackOpen")}
            message={companyDialogMessages[this.state.messageId]}
          />
          <div className="app-panel-content">
            <Paper
              elevation={4}
              style={{ padding: "16px ", minHeight: "65px" }}
            >
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="dark-btn"
                style={{ float: "right" }}
                onClick={(): * => this.switchModalStatus("modalOpen")(true)}
              >
                <BatteryCharging90Icon className="light-icon right-margin-5" />
                Generate Last Bill
              </Button>
              <GeneralModalForm
                title="Generate Last Bill"
                open={this.state.modalOpen}
                handleModalStatus={this.switchModalStatus("modalOpen")}
                form={
                  <GenerateBillForm
                    onClose={(): * =>
                      this.switchModalStatus("modalOpen")(false)
                    }
                  />
                }
              />
            </Paper>
          </div>
          {node}
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  companies: state.v3admin.billing.companies
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchCompanies }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminBillings);
